<template>
  <div class="order-page">
    <!-- <h1>推广单元</h1> -->
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="plan_name"
                          label="所属计划">
              <el-input v-model="form.plan_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width
                          prop="tgdy_name"
                          label="推广单元名称">
              <el-input v-model="form.tgdy_name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <el-date-picker v-model="form.create_time"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport"></action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"
                       width="100px"></el-table-column>
	


  <el-table-column prop="plan_name"
                       align="center"
                       header-align="center"
                       label="计划名称"
                       min-width="100px"
                       show-overflow-tooltip></el-table-column>
					   
					   
	  <el-table-column prop="tgdy_name"
				   align="center"
				   header-align="center"
				   label="单元名称"
				   min-width="100px"
				   show-overflow-tooltip></el-table-column>			   
					   
					   
      <el-table-column prop="zxliang"
                       align="center"
                       header-align="center"
                       label="展现量"></el-table-column>
      <el-table-column prop="zrllzlbg"
                       align="center"
                       header-align="center"
                       label="自然流量增量曝光"></el-table-column>
      <el-table-column prop="xh"
                       align="center"
                       header-align="center"
                       label="消耗"></el-table-column>
      <el-table-column prop="cdfks"
                       align="center"
                       header-align="center"
                       label="触达访客数"></el-table-column>
      <el-table-column prop="qczxcb"
                       align="center"
                       header-align="center"
                       label="千次展现成本（元）"></el-table-column>
					   
					   


      <el-table-column prop="djdj"
                       align="center"
                       header-align="center"
                       label="点击单价"></el-table-column>
      <el-table-column prop="tzdjdj"
                       align="center"
                       header-align="center"
                       label="跳转点击单价"></el-table-column>
      <el-table-column prop="djl"
                       align="center"
                       header-align="center"
                       label="点击量"></el-table-column>
      <el-table-column prop="tzdjl"
                       align="center"
                       header-align="center"
                       label="跳转点击量"></el-table-column>
      <el-table-column prop="djfks"
                       align="center"
                       header-align="center"
                       label="点击访客数"></el-table-column>
					   
					   
					   
      <el-table-column prop="hddjl"
                       align="center"
                       header-align="center"
                       label="互动点击量"></el-table-column>
      <el-table-column prop="djlv"
                       align="center"
                       header-align="center"
                       label="点击率"></el-table-column>
      <el-table-column prop="tzdjlv"
                       align="center"
                       header-align="center"
                       label="跳转点击率"></el-table-column>
      <el-table-column prop="jdfks"
                       align="center"
                       header-align="center"
                       label="进店访客数"></el-table-column>
      <el-table-column prop="dpscs"
                       align="center"
                       header-align="center"
                       label="店铺收藏数"></el-table-column>
					   
					   
					   
	
					   
      <el-table-column prop="bbscs"
                       align="center"
                       header-align="center"
                       label="宝贝收藏数"></el-table-column>
      <el-table-column prop="bbjgs"
                       align="center"
                       header-align="center"
                       label="宝贝加购数"></el-table-column>
      <el-table-column prop="xdfks"
                       align="center"
                       header-align="center"
                       label="行动访客数"></el-table-column>
      <el-table-column prop="dpscfks"
                       align="center"
                       header-align="center"
                       label="店铺收藏访客数"></el-table-column>
      <el-table-column prop="bbscfks"
                       align="center"
                       header-align="center"
                       label="宝贝收藏访客数"></el-table-column>
					   
					   
					   
	  <el-table-column prop="bbjgfks"
                       align="center"
                       header-align="center"
                       label="宝贝加购访客数"></el-table-column>
      <el-table-column prop="cjbs"
                       align="center"
                       header-align="center"
                       label="成交笔数"></el-table-column>
      <el-table-column prop="cjje"
                       align="center"
                       header-align="center"
                       label="成交金额"></el-table-column>
      <el-table-column prop="roi"
                       align="center"
                       header-align="center"
                       label="回报率"></el-table-column>
      <el-table-column prop="ctr"
                       align="center"
                       header-align="center"
                       label="转化率"></el-table-column>		   
					   

	  <el-table-column prop="zrllzlcj"
                       align="center"
                       header-align="center"
                       label="自然流量增量成交"></el-table-column>
      <el-table-column prop="yscjbs"
                       align="center"
                       header-align="center"
                       label="预售成交笔数"></el-table-column>
      <el-table-column prop="yscjje"
                       align="center"
                       header-align="center"
                       label="预售成交金额"></el-table-column>
      <el-table-column prop="cjfks"
                       align="center"
                       header-align="center"
                       label="成交访客数"></el-table-column>
      <el-table-column prop="ssjdl"
                       align="center"
                       header-align="center"
                       label="搜索进店率"></el-table-column>	
					   
					   
	  <el-table-column prop="jdxdl"
                       align="center"
                       header-align="center"
                       label="进店行动率"></el-table-column>
      <el-table-column prop="xdcjl"
                       align="center"
                       header-align="center"
                       label="行动成交率"></el-table-column>	
     
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/promote/starstore-promotionunit/index.vue